import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'

import type { Feature } from '../feature'
import * as gql from '../gql'

/**
 * Executes delete requests from the route-bound scenario dropdown.
 */
export const submitDeleteOnRequest = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.submitDelete.request.observe().pipe(
      rxjs.withLatestFrom(
        feature.selectors.deleteDialog.asObservable,
        meFeature.contexts.selectors.appContext.asObservable,
      ),
      rxjs.exhaustMap(([action, deleteDialog, appContext]) => {
        if (!deleteDialog) {
          return rxjs.of(
            feature.actions.submitDelete.cancellation.from(action).create({
              reason: 'No scenario is marked for deletion',
              request: action.data,
            }),
          )
        }
        if (!appContext) {
          return rxjs.of(
            feature.actions.submitDelete.cancellation.from(action).create({
              reason: 'No app context available',
              request: action.data,
            }),
          )
        }

        return gql.mutations.deleteScenario
          .executor({
            ...appContext,
            scenarioId: deleteDialog.scenarioId,
          })
          .pipe(
            rxjs.mergeMap(response =>
              rxjs.of(
                feature.actions.submitDelete.success.from(action).create({
                  request: action.data,
                  response,
                }),
                feature.actions.refreshScenarios.request
                  .from('RouteBoundScenarios.SubmitDelete.Success')
                  .create(),
              ),
            ),
            rxjs.catchError((error: Error) =>
              rxjs.of(
                feature.actions.submitDelete.error.from(action).create({
                  error,
                  request: action.data,
                }),
              ),
            ),
          )
      }),
    ),
)
